<ng-container *ngIf="ready && (isFirstPage$ | async) === false && heading">
  <div class="stepHeading noCounter">
    <h1
      class="ng-binding mw568"
      dir="{{ dir$ | async }}"
      [innerHTML]="headingText"
    ></h1>
  </div>
</ng-container>
<ng-container *ngIf="ready && (isFirstPage$ | async) && heading">
  <h2 class="mw568 tc firstHeading" [innerHTML]="headingText"></h2>
</ng-container>
<ng-container *ngIf="ready && content && (isForm$ | async) === false">
  <app-content-repeater [items]="content"></app-content-repeater>
</ng-container>
